import { ApiAction, PaginatedApiState, initialPaginatedApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import PreorderDetail from '../../models/PreorderDetail';

export interface PreorderDetailListState extends PaginatedApiState {
  preorderDetail?: PreorderDetail[]
}

const PreorderDetailList = (state: PreorderDetailListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    case 'PREORDER_DETAIL_CLEAR':
          return { ...state, preorderDetail: [] }
    default:
      return requestReducer<PreorderDetailListState>('PREORDER_DETAIL_LIST')(state, action)
  }
}

export default PreorderDetailList